export enum ElementType {
  TEXT = 'TEXT',
  SHAPE = 'SHAPE',
  IMAGE = 'IMAGE',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  LOTTIE = 'LOTTIE'
}
